import MinesBoardCells from '@/components/Mines/Content/Board/Cells';
import TowerCells from '@/components/Tower/Content/Board/Cells';
import { GameID } from '@/enums/gameId';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { DetailedBet } from '@/models/detailed-bet';
import { Either } from '@starsoft/common/interfaces';
import CoinFlipGameBoard from './Coinflip';
import DiceGameReportBoard from './Dice';
import LimboGameBoardReport from './Limbo';
import MissionUncrossableGameReportBoard from './MissionUncrossable';

export default function GameDetailsContentBoardBet() {
  const { gameId } = useGameReportSearchParams();
  const { bets } = useGameReportData();
  const bet: Either<DetailedBet, undefined> = bets?.[0];

  switch (gameId?.toString()) {
    case GameID.Coinflip?.toString():
      return <CoinFlipGameBoard bet={bet as DetailedBet} />;
    case GameID.Dice?.toString():
      return <DiceGameReportBoard bet={bet as DetailedBet} />;
    case GameID.Limbo?.toString():
      return <LimboGameBoardReport bet={bet as DetailedBet} />;
    case GameID.Mines?.toString():
      return (
        <MinesBoardCells
          bet={bet}
          isBoletim
          isDisabled
          isBackgroundPaper
          onClick={() => {}}
        />
      );
    case GameID.Tower?.toString():
      return (
        <TowerCells
          bet={bet}
          difficulty={bet?.grid?.difficulty?.tower}
          rowsCleared={bet?.grid?.position}
          isBoletim
        />
      );
    case GameID.Splash?.toString():
      return <MissionUncrossableGameReportBoard bet={bet as DetailedBet} />;
  }
}
